<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>
    <h3 class="text-center">Mis inscripciones realizadas</h3>
    <form class="xcard" @submit.prevent="validarDatos" style="margin-top: 0; background: #e9f2f7" novalidate>
      <div class="row">
        <div class="col-sm-2">
          <input type="text" class="form-control input-sm" v-model="buscar" placeholder="Buscar en la tabla" />
          <small>Busqueda rapida</small>
        </div>
        <div class="col-sm-2" :class="{ 'has-error': validation.hasError('busqueda.fecha_ini') }">
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini" />
          <small>Inscripciones desde</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')">
            {{ validation.firstError('busqueda.fecha_ini') }}
          </div>
        </div>
        <div class="col-sm-2" :class="{ 'has-error': validation.hasError('busqueda.fecha_fin') }">
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin" />
          <small>Inscripciones hasta</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')">
            {{ validation.firstError('busqueda.fecha_fin') }}
          </div>
        </div>

        <div class="col-sm-6">
          <button class="btn btn-sm btn-azul"><span class="glyphicon glyphicon-search"></span> Buscar</button>
          <router-link to="misinscripciones2" class="ml-1 btn btn-sm btn-success white--text">
            <span class="glyphicon glyphicon-eye-open white--text"></span> Buscar por asesor</router-link
          >
          <button v-show="false" class="btn btn-sm btn-link" @click="generarReporte()">
            <span class="glyphicon glyphicon-print"></span> Reporte PDF
          </button>
          <button
            :disabled="$store.state.isonlyread"
            v-show="inscripciones.length > 0"
            class="btn btn-sm btn-link"
            @click="tableToExcel('table', 'Inscritos')">
            <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
          </button>
        </div>
      </div>
    </form>

    <div class="table-responsive">
      <label>
        <input type="checkbox" v-model="contraercolumnas" /> Contraer columnas
        <small>(Ocultar las columnas no necesarias)</small>
      </label>
      <p class="text-primary">{{ msg }}</p>
      <div class="text-center">
        <div style="display: inline-block" v-show="loading" class="loader"></div>
      </div>
      <table
        ref="table"
        class="table table-condensed table-striped table-hover"
        summary="lorem ipsum sit amet"
        rules="groups"
        frame="hsides"
        id="midatatable">
        <caption v-show="false">
          Reporte de inscripciones:
          {{
            nom_us
          }},
          {{
            fec_us
          }}
        </caption>
        <thead style="background: #196391">
          <tr>
            <th class="white--text">Nro</th>
            <th class="white--text" style="min-width: 100px">Apellido 1</th>
            <th class="white--text" style="min-width: 100px">Apellido 2</th>
            <th class="white--text" style="min-width: 160px">Nombres</th>
            <th v-if="!contraercolumnas" class="white--text" style="min-width: 90px">Documento</th>
            <th v-if="!contraercolumnas" class="white--text">Telefono</th>
            <th v-if="!contraercolumnas" class="white--text">Correo</th>
            <th v-if="!contraercolumnas" class="white--text">Programa</th>
            <th v-if="!contraercolumnas" class="white--text">Sede</th>
            <th v-if="!contraercolumnas" class="white--text">Inscrito</th>
            <th v-if="!contraercolumnas" class="white--text">Estado</th>
            <th class="white--text" v-show="false">Tel. Fijo</th>
            <th class="white--text" v-show="false">Profesion</th>
            <th class="white--text" v-show="false">Observacion</th>
            <th class="white--text" v-show="false">Universidad</th>
            <th class="white--text" v-show="false">Genero</th>
            <th class="white--text" v-show="false">Domicilio</th>
            <th class="white--text" style="min-width: 120px">Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ins.id" v-for="(ins, ind) in inscripciones">
            <td :title="'ID inscripcion: ' + ins.id">{{ ind + 1 }}</td>
            <td :title="'ID Estudiante: ' + ins.estudiante.id">{{ parseApellidos(ins.estudiante, 1) }}</td>
            <td :title="'ID Estudiante: ' + ins.estudiante.id">{{ parseApellidos(ins.estudiante, 2) }}</td>
            <td>{{ ins.estudiante.nombres }}</td>
            <td v-if="!contraercolumnas">{{ parseDoc(ins.estudiante) }}</td>
            <td v-if="!contraercolumnas">
              <a href="#" @click="whatsapp(ins.estudiante.telefono1)"> {{ ins.estudiante.telefono1 }} </a>
            </td>
            <td v-if="!contraercolumnas">{{ ins.estudiante.email }}</td>
            <td v-if="!contraercolumnas" :title="ins.estudiante.nombres">{{ parsePrograma(ins.programa) }}</td>
            <td v-if="!contraercolumnas">{{ parseSede(ins.programa) }}</td>
            <td v-if="!contraercolumnas">{{ parseFecha(ins.fecha_registro) }}</td>
            <td v-if="!contraercolumnas" :style="parseInsColor(ins.estado_ins)">{{ parseIns(ins.estado_ins) }}</td>
            <td v-show="false">{{ ins.estudiante.telefono2 }}</td>
            <td v-show="false">{{ getProfesion(ins.estudiante.profesiones) }}</td>
            <td v-show="false">{{ getObservacion(ins.observaciones) }}</td>
            <td v-show="false">{{ getInstitucion(ins.estudiante.institucion) }}</td>
            <td v-show="false">{{ getGenero(ins.estudiante) }}</td>
            <td v-show="false">{{ ins.estudiante.domicilio }}</td>
            <td>
              <button
                v-if="ins.estado_ins == 1"
                type="button"
                :disabled="loadingpdf"
                class="btn btn-sm btn-default"
                @click="formulariopdf(ins)"
                title="Formulario de inscripcion">
                <span class="glyphicon glyphicon-download"></span>
              </button>

              <button
                v-if="ins.estado_ins == 1"
                type="button" 
                class="btn btn-sm btn-default"
                @click="open_expedientes(ins)"
                title="Expedientes ISPI">
                <span class="glyphicon glyphicon-floppy-save"></span>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-default"
                title="Editar informacion del estudiante"
                @click="editar(ins.estudiante)">
                <span class="glyphicon glyphicon-pencil"></span>
              </button>

              <button
                v-if="$store.state.deleteInscripcion"
                type="button"
                class="btn btn-sm btn-default"
                @click="preEliminarInscripcion(ins.id, ins.programa)">
                <span class="glyphicon glyphicon-trash"></span>
              </button>

              <button
                v-if="ins.estado_ins == 0"
                title="Cambiar a inscrito"
                class="btn btn-sm btn-default"
                @click="cambiarEstado(ins)">
                <span class="glyphicon glyphicon-random"></span>
              </button>

              <!-- <button
                vv-if="ins.estado_ins==0"
                title="Generar plan de pagos"
                class="btn btn-sm btn-default"
                @click="generarplan(ins)">
                <span class="glyphicon glyphicon-credit-card"></span>
              </button> -->

              <v-progress-linear v-if="loadingpdf" indeterminate color="indigo"></v-progress-linear>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
    <div v-show="false"><Formulariopdf ref="formulariopdf" v-on:onmsgpdf="onmsgpdf" /></div>

    <Detalle id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <Cambio id="modalcam" :model="precambio" v-on:exito="modalExito" />
    <menuExp ref="refmenu" />
  </div>
</template>

<script>
  import { generarInscripcionesR } from '@/components/generar-inscripciones.js';
  import { Validator } from 'simple-vue-validator';
  import Detalle from '@/components/ADetalleInscrito';
  import Formulariopdf from '@/components/AFormularioPDF.vue';
  import Cambio from '@/views/CambioPrograma';
  import Fecha from '@/components/AFecha.vue';
  import menuExp from '../components/expedientesispi/menu.vue';
  import { error, strFechaBusqueda, parseJsonError } from '@/components/Utils.js';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        buscar: '',
        msg: '',
        nom_us: '',
        fec_us: '',
        loadingpdf: false,
        loading: false,
        contraercolumnas: false,
        ispermitidoporasesor: false,
        idNewInscripcion: 0,
        seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        pagarMatricula: { id: -1 },
        precambio: { id: -1, idasesor: -1, ins: null },
        inscripciones: [],
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
      };
    },
    components: { Cambio, Fecha, Detalle, Formulariopdf,menuExp },
    validators: {
      'busqueda.fecha_ini'(value) {
        return Validator.value(value).required();
      },
      'busqueda.fecha_fin'(value) {
        return Validator.value(value).required();
      },
    },
    watch: {
      buscar: function () {
        this.myFunction1(this.buscar);
      },
      '$store.state.DATA_USER': function () {
        this.gen_nom_us();
      },
      'busqueda.fecha_ini': function () {
        this.parseFecha2();
      },
      'busqueda.fecha_fin': function () {
        this.parseFecha2();
      },
    },
    methods: {
      generarReporte() {
        generarInscripcionesR(this.inscripciones, this.busqueda, this.$store.state.DATA_USER);
      },
      formulariopdf(ins) {
        window.console.log(ins);
        this.$refs.formulariopdf.getpersonainfo(ins.estudiante.id, ins.programa.id, ins.id, this);
      },
      open_expedientes(ins){
        window.console.log(ins);
        this.$refs.refmenu.openmodal(ins);
      },
      gen_nom_us() {
        var data_user = this.$store.state.DATA_USER;
        if (!data_user) return;
        if (!data_user.seg_apellido) data_user.seg_apellido = '';
        this.nom_us = data_user.nombres + ' ' + data_user.pri_apellido + ' ' + data_user.seg_apellido;
      },
      parseFecha2() {
        var fe = this.busqueda.fecha_ini;
        var fe2 = this.busqueda.fecha_fin;
        if (!fe) fe = '- -';
        if (!fe2) fe2 = '- -';
        var vs = fe.split('-');
        var vs2 = fe2.split('-');
        this.fec_us = 'DEL: ' + vs[2] + '/' + vs[1] + '/' + vs[0] + ' AL ' + vs2[2] + '/' + vs2[1] + '/' + vs2[0];
      },
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'inscripciones.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      parsePrograma(p) {
        if (p == null) return '';
        var cat = p.postgrado.categoria.nombre;
        var nom = p.nombre_compuesto;
        nom = nom.replace('- ' + cat, '- ');
        return nom;
      },
      parseEstudiante(e) {
        if (e == null) return '';
        var seg = e.seg_apellido;
        if (seg == null) seg = '';
        return e.nombres + ' ' + e.pri_apellido + ' ' + seg;
      },
      /*parseApellidos( e ){
        if( e == null ) return "";
        var seg = e.seg_apellido;
        if( seg == null ) seg = "";
        return e.pri_apellido+" "+seg;
      },*/
      parseApellidos(e, unodos) {
        if (e == null) return '';
        var seg = e.seg_apellido;
        if (seg == null) seg = '';
        if (unodos == 1) return e.pri_apellido;
        else return seg;
        //return e.pri_apellido+" "+seg;
      },
      getProfesion(profs) {
        if (!profs || profs.length == 0) return '-';
        var p = profs[0];
        return p.nombre;
      },
      getObservacion(ob) {
        if (!ob) return '';
        return ob;
      },
      getInstitucion(inst) {
        if (!inst) return '-';
        return inst.abreviatura + ' - ' + inst.nombre;
      },
      getGenero(est) {
        if (!est) return '-';
        return est.sexo;
      },
      parseSede(p) {
        if (p == null) return '';
        if (p.sede == null) return '-';
        return p.sede.nombre;
      },
      parseFecha(f) {
        var date = new Date(f);
        var a = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        if (m < 10) m = '0' + m;
        if (d < 10) d = '0' + d;
        return d + '/' + m + '/' + a;
      },
      parseIns(ins) {
        /*if (ins == 0) return "Pre inscrito";
            else if (ins == 1) return "Inscrito";
            else return " " + ins;*/
        var str = '';
        if (ins == 0) str = 'Pre inscrito';
        else if (ins == 1) str = 'Inscrito';
        else if (ins == 2) str = 'retirado';
        else if (ins == 3) str = 'cambiado';
        else if (ins == 4) str = 'congelado';
        else if (ins == 5) str = 'pagado';
        return str;
      },
      parseInsColor(ins) {
        /*if (ins == 0) return "background:#EFFFA8";
            else if (ins == 1) return "background:#A8FFA8";
            else if (ins == 2) return "background:#D9F0D9";
            else if (ins == 3) return "background:#FFC8A8";
            else return "";*/
        if (ins == 0) return 'background:#EFFFA8';
        else if (ins == 1) return 'background:#A8FFA8';
        else if (ins == 2) return 'background:#FFA8B1';
        else if (ins == 3) return 'background:#FFE0A8';
        else if (ins == 4) return 'background:#A8D3FF';
        else if (ins == 5) return 'background:#FFA8F2';
        else return '';
      },
      parseDoc(es) {
        if (es == null) return ' ';
        else if (es.num_doc == null) return ' ';
        var ext = '-';
        if (es.departamento != null) ext = es.departamento.extension;
        return es.num_doc + ' ' + ext;
      },
      validarDatos() {
        this.inscripciones = [];
        this.msg = '';
        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.busqueda);
          if (success) {
            if (obj.fecha_ini == obj.fecha_fin) {
              this.$notify(error('Fechas invalidas', 'Las fechas deben tener al menos un dia de diferencia'));
              return;
            }
            this.loading = true;
            this.buscarInscripciones(obj);
          } else {
            this.loading = false;
          }
        });
      },
      buscarInscripciones(obj) {
        var vue = this;
        var sql = gql`query{ misInscripciones(fechas:${window.stringifyObject(obj)})
      { id,estado_ins,fecha_registro,asesor{id},estudiante{id,email,num_doc,telefono1,telefono2,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},ciudad{nombre},profesiones{id,nombre},estado,institucion{id,nombre,abreviatura},domicilio,fecha_nac,est_civil},programa{id,version,grupo,fecha_inicio,fecha_fin,sede{nombre},nombre_compuesto,postgrado{nombre,categoria{nombre}}}} }`;
        vue.msg = '';
        //window.console.log(sql.loc.source.body);
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            vue.inscripciones = data.data.misInscripciones;
            if (!vue.inscripciones) vue.inscripciones = [];
            this.msg = this.inscripciones.length + ' Resultados, del ' + strFechaBusqueda(vue.busqueda);
            this.loading = false;
            // window.console.log( vue.inscripciones );
          })
          .catch((error) => {
            this.msg = error;
            window.console.error(error);
            this.$notify(parseJsonError(error, 'misInscripciones'));
          });
      },
      modalExito() {},
      verDetalles(id) {
        // window.console.log( "ID DETALLE: ",id );
        var msg = 'Detalle de la inscripcion';
        var body = 'Detalles';
        var tag = gql`
        query{
          getInscripcion(id:${id}){
            id,estado_ins,observaciones,fecha_registro,matricula{monto,saldo},
            monto_colegiatura,monto_certificacion, 
            cuotas,lista_cuotas{monto,saldo,fecha},certificacion{monto,saldo}
          }
        }
        `;
        this.seleccionado = { xid: 12, xtitle: msg, xbody: body, xsql: tag };
      },
      pagos(id) {
        window.sessionStorage.setItem('xins', JSON.stringify(id));
        window.sessionStorage.setItem('routerTo', 'misinscripciones');
        this.$router.push({ name: 'pagos' });
      },
      cambioPrograma(ins) {
        // window.console.log( ins )
        this.precambio.id = ins.id;
        this.precambio.idasesor = ins.asesor.id;
        this.precambio.ins = ins;
      },
      cambiarEstado(ins) {
        /*window.sessionStorage.setItem( 'preins',JSON.stringify(ins) );
        this.$router.push({name:'cambiarPreins'});*/

        // window.console.log(ins);
        this.$store.dispatch('inscripcion/selectInscripcion', ins);
        ins.programa.estudiante_id = ins.estudiante.id;
        window.sessionStorage.setItem('xprograma', JSON.stringify(ins.programa));
        window.sessionStorage.setItem('xpreinscrito', JSON.stringify(ins));
        this.$router.push({ name: 'inscripcionrest' });
      },
      generarplan(ins) {
        // window.console.log(ins);
        window.sessionStorage.removeItem('xpreinscrito');
        window.sessionStorage.setItem('xprograma', JSON.stringify(ins.programa));
        window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(ins));
        this.$router.push({ name: 'inscripcionrest' });
      },
      whatsapp(tel) {
        window.open(`${process.env.VUE_APP_API_WHATSAPP}591` + tel + '&text=Hola');
      },
      getFechasDefault() {
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth() + 1;
        if (d == 1) d = 2;
        if (d < 10) d = '0' + d;
        if (m < 10) m = '0' + m;
        var ini = date.getFullYear() + '-' + m + '-01';
        var fin = date.getFullYear() + '-' + m + '-' + d;
        this.busqueda.fecha_ini = ini;
        this.busqueda.fecha_fin = fin;
        this.validarDatos();
      },
      preEliminarInscripcion(/*idins, programa*/) { 
        this.$root.$notify.show(`No tienes permitido realizar esta accion.`, {
          color: 'red',
          x: 'right',
        });
        return;
        /*this.loading = false;
        this.idNewInscripcion = idins;
        var vue = this;
        var opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar esta inscripcion.',
          animation: 'bounce',
          type: 'hard',
        };
        this.$dialog
          .confirm(
            'Confirmacion<br><br>Esta accion es irreversible, solo se puede eliminar una inscripcion cuando no haya cancelado ningun pago.<br>',
            opt,
          )
          .then(function () {
            vue.eliminarInscripcion(programa);
          })
          .catch(function (e) {
            window.console.error(e);
          });*/
      },
      onmsgpdf(msg) {
        let noti = { group: 'auth', title: '', text: msg, duration: 5000 };
        this.$notify(noti);
      },
      editar(est) {
        //window.console.log('EDITAR::', window.stringifyObject(est));
        window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
        window.sessionStorage.setItem('xxatrs', 'programains');
        this.$router.push({ name: 'estudiantesmod' });
      },
      eliminarInscripcion(programa) {
        var vue = this;
        /*this.$refs.xalertar.cargando('Eliminando inscripcion...');
      var sql = gql`mutation{ deleteInscripcion(input:{ id:${this.idNewInscripcion},idprograma: ${programa.id} }){ok,errors{message}} }`;
      this.idNewInscripcion = 0;

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.deleteInscripcion.ok) {
            vue.$refs.xalertar.success('Inscripcion eliminada.');
            vue.$notify(exito('Eliminado', 'El participante fue eliminado.'));
            vue.idNewInscripcion = 0;
            vue.validarDatos();
          } else {
            var errores = JSON.stringify(data.data.deleteInscripcion.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            vue.msg = '';
            vue.activo = true;
            vue.$refs.xalertar.invalido(vals);
            vue.$notify(error('No Eliminado', vals));
          }
        })
        .catch((error) => {
          this.activo = true;
          window.console.error(error);
          vue.$refs.xalertar.invalido('No se pudo eliminar la inscripcion, ya hizo pagos.');
          vue.$notify(parseJsonError(error, 'deleteInscripcion'));
        });*/
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idNewInscripcion}`;
        window.console.log(url);
        xaxios
          .delete(url)
          .then((res) => {
            window.console.log(res, programa);
            vue.inscripciones = vue.inscripciones.filter((x) => x.id != vue.idNewInscripcion);
            let noti = { group: 'auth', title: '', text: res.data.data, duration: 5000 };
            vue.$notify(noti);
          })
          .catch((error) => {
            window.console.error(error);
            this.activo = true;
            //vue.$refs.xalertar.invalido(error.response.data.data);
            let noti = {
              group: 'auth',
              title: 'Se ha producido un error',
              text: error.response.data.data,
              duration: 10000,
              type: 'error',
            };
            vue.$notify(noti);
          });
      },
      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },
    },
    mounted() {
      let cargo = this.$store.state.CARGO;
      if (cargo) {
        this.ispermitidoporasesor = cargo.id >= 14;
      }
      this.getFechasDefault();
      this.gen_nom_us();
    },
  };
</script>
